<script setup lang="ts">
import Button from 'primevue/button'
import { computed } from 'vue'
import { useChatStore } from '@/modules/chat'
import { chatInitials } from './chatDisplay'

/** Campos extra que enviamos desde `showChatIncomingToast` + estándar PrimeVue */
type TToastMessage = {
  summary?: string
  detail?: string
  peerUlid?: string
  chat_ulid?: string
  type?: 'direct' | 'group'
  senderName?: string
  bodyPreview?: string
}

const props = defineProps<{
  message: TToastMessage
  closeCallback: () => void
}>()

const chat = useChatStore()

const displayName = computed(
  () =>
    props.message.senderName?.trim() ||
    props.message.summary?.trim() ||
    'Usuario',
)

const previewText = computed(
  () => props.message.bodyPreview?.trim() || props.message.detail?.trim() || '',
)

const initials = computed(() => chatInitials(displayName.value))

const onReply = () => {
  const peerUlid = props.message.peerUlid
  const chatUlid = props.message.chat_ulid
  const type = props.message.type ?? 'direct'
  if (type === 'group' && chatUlid) {
    chat.openConversation({
      type: 'group',
      chat_ulid: chatUlid,
      display_name: displayName.value,
    })
    props.closeCallback()
    return
  }
  if (!peerUlid) return
  chat.openConversation({
    type: 'direct',
    peer_ulid: peerUlid,
    chat_ulid: chatUlid,
    display_name: displayName.value,
  })
  props.closeCallback()
}
</script>

<template>
  <div class="flex w-full max-w-sm gap-3 rounded-xl p-3 flex-col">
    <div class="flex items-center gap-2">
      <Avatar :label="initials" shape="circle" />
      <span class="truncate text-sm font-semibold">{{ displayName }}</span>
    </div>

    <div class="min-w-0 flex-1">
      <p
        class="mt-1 line-clamp-4 whitespace-pre-wrap wrap-break-word text-xs leading-snug"
      >
        {{ previewText }}
      </p>
    </div>
    <footer class="flex items-center w-full justify-end">
      <Button
        icon="pi pi-reply"
        severity="secondary"
        size="small"
        text
        @click="onReply"
      />
    </footer>
  </div>
</template>
